/**
 * Expone la version del package en la variable global `edicom`.
 *
 * @example
 * // package: form-edicom-components.js
 * import { name, version } from './package.json';
 * setVersionInEdicom(name, version)
 *
 * // consola:
 * edicom.versions -> '@edicom/form-edicom-components': 22.1.1
 *
 * @param {string} name el nombre del componente/package
 * @param {string} version
 */
export function setVersionInEdicom(name, version) {
  window.edicom = window.edicom ?? {};
  window.edicom.versions = window.edicom.versions ?? {};
  window.edicom.versions[name] = version;
}
